import ApiClient from 'remote/api-client';
import { Invoice } from 'types/invoice';

// Get all invoices for the current tenant.
// The invoices are sorted by creation date, with the most recently created invoice appearing first.
const list = (tenantId: string): Promise<Invoice[]> =>
  ApiClient.get(`/tenants/${tenantId}/billing/invoices`).promise();

export default { list };
